







































































import Transactions from '@/components/TransactionTickets/Monitor/Transactions.vue';
import { createConsumer } from '@rails/actioncable';
import Detail from '@/components/TransactionTickets/Records/DetailModal.vue';
import statType from '@/store/types/stats';
import { risk } from '@/util/transformString/translationsDecorator';
import DatesFormat from '@/util/classes/datesFormat';
import alert from '@/assets/sounds/alert.mp3';
import { TransactionParams } from '@/store/interfaces/transactions';
import { allowAny, tPropsToSearch, tTableColumns } from 'teip-components';
import transaction from '@/store/types/transaction';
import { TableRef } from '@/store/interfaces/generic';
import PaymentMethods from '@/components/Reusable/paymentMethods.vue';
import StatusBadges from '@/components/Reusable/statusBadges.vue';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

const formatDate = new DatesFormat();

export default Vue.extend({
  name: 'MonitorHome',
  components: {
    Detail,
    Transactions,
    StatusBadges,
    PaymentMethods,
  },
  data: () => ({
    audio: new Audio(alert),
    enableSound: false,
    loading: true,
    viewDetails: false,
    propsToSearch: [] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'commerce_name',
        label: 'Comercio',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'branch_name',
        label: 'Sucursal',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'user_name',
        label: 'Usuario',
        minWidth: 280,
        sortable: true,
      },
      {
        prop: 'subtotal_formatted',
        label: 'Subtotal',
        minWidth: 150,
        sortable: true,
      },
      {
        prop: 'tip_formatted',
        label: 'Propina',
        minWidth: 100,
        sortable: true,
      },
      {
        prop: 'discount_formatted',
        label: 'Descuento',
        minWidth: 150,
        sortable: true,
      },
      {
        prop: 'total_formatted',
        label: 'Total',
        minWidth: 100,
        sortable: true,
      },
      {
        prop: 'status',
        label: 'Estado',
        minWidth: 150,
        sortable: true,
        slotName: 'status',
      },
      {
        prop: 'kind_name',
        label: 'Tipo de orden',
        minWidth: 130,
      },
      {
        prop: 'card',
        label: 'Método de pago',
        minWidth: 180,
        sortable: true,
        slotName: 'card',
      },
      {
        prop: 'created_at',
        label: 'Fecha y Hora',
        minWidth: 180,
        sortable: true,
        formatter: (row: TransactionParams): string => {
          return `${formatDate.formatDateTime(row.created_at)}`;
        },
      },
      {
        prop: 'risk',
        label: 'Riesgo',
        minWidth: 100,
        sortable: true,
        formatter: (row: TransactionParams): string => {
          return `${risk(String(row.risk))}`;
        },
      }
    ] as tTableColumns,
    rowSelected: {
      authorization_number: '',
      branch_name: '',
      card_last_digits: '',
      biometrics: false,
      card_network: '',
      city_code: '',
      commerce_name: '',
      country_code: '',
      created_at: '',
      discount_cents: 0,
      discount_currency: '',
      order_kind: 'qr',
      kind_name: '',
      discount_formatted: '',
      id: '',
      latitude: '',
      logo: '',
      longitude: '',
      reference_number: '',
      response_code: '',
      risk: '',
      state_code: '',
      status: 'pending',
      subtotal_cents: 0,
      subtotal_currency: '',
      subtotal_formatted: '',
      tip_cents: 0,
      tip_currency: '',
      tip_formatted: '',
      total_cents: 0,
      total_currency: '',
      total_formatted: '',
      updated_at: '',
      user_name: '',
      device_name: '',
      device_platform: '',
      device_version: '',
      device_vendor: '',
      requestable_type: '',
      requestable_id: '',
      user_id: '',
      balance_amount_cents: null,
      balance_amount_currency: null,
      balance_amount_formatted: null,
      card_amount_cents: null,
      card_amount_currency: null,
      card_amount_formatted: null,
      description: '',
      distribution: 'not_assigned',
      expires_at: 1,
    } as TransactionParams,
    showevent: false,
    cable: null as allowAny,
  }),
  async mounted() {
    await this.getStats();
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const ctx = this;
    this.cable = createConsumer(process.env.VUE_APP_WS_HOST);
    this.cable.subscriptions.create(
      { channel: 'TransactionChannel', },
      {
        received() {
          ctx.reFetchData();
        },
      }
    );
    this.loading = false;
  },
  destroyed() {
    this.cable.subscriptions.consumer.disconnect();
  },
  computed: {
    ...mapGetters({
      getTransactionList: `transactionModule/${transaction.getters.GET_POSTMORTEM_TRANSACTIONS}`,
      stats: `statsModule/${statType.getters.STATS}`,
    }),
  },
  methods: {
    ...mapActions({
      transactionList: `transactionModule/${transaction.actions.MONITOR_TRANSACTION_LIST}`,
      getStats: `statsModule/${statType.actions.GET_STATS}`,
    }),
    reFetchData() {
      this.getStats();
      (this.$refs.table as TableRef).fetchData();
      if (this.enableSound) {
        this.playSound();
      }
    },
    playSound() {
      this.audio.play();
    },
    rowselect(row: TransactionParams) {
      this.rowSelected = row;
    },
    viewDetailsAction() {
      this.viewDetails = true;
    },
  },
});
